import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import { nameToUrl } from '../../utils/url';
import { formatDate } from '../../utils/date';

const ResultLink = ({
    courseName,
    courseUid,
    raceDatetime,
    raceDate,
    raceInstanceUid,
    raceInstanceTitle,
    children,
    className,
    urlHash,
}) => {
    const date = raceDatetime || raceDate;
    if (!courseUid || !courseName || !date || !raceInstanceUid) {
        return <span className={className}>—</span>;
    }

    const urlDate = formatDate(date, 'Y-MM-DD');
    const name = nameToUrl(courseName);
    const hash = urlHash ? `#${urlHash}` : '';
    const url = `/results/${courseUid}/${name}/${urlDate}/${raceInstanceUid}${hash}`;

    return (
        <a
            className={classNames('ui-link ui-link_table js-popupLink', className)}
            href={url}
            title={raceInstanceTitle}
        >
            { children || raceInstanceTitle }
            <Svg
                iconName="right"
                className="ui-icon ui-icon__btn chevronIcon"
                size="XSmall"
            />
        </a>
    );
};

ResultLink.defaultProps = {
    urlHash: '',
};

ResultLink.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceDate: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    urlHash: PropTypes.string,
};

export default ResultLink;



// WEBPACK FOOTER //
// ./src/js/shared/links/ResultLink.jsx